
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_1612d_rf2xh_35",
  "spinner-rotator": "awsui_spinner-rotator_1612d_rf2xh_1",
  "size-normal": "awsui_size-normal_1612d_rf2xh_43",
  "size-big": "awsui_size-big_1612d_rf2xh_51",
  "size-large": "awsui_size-large_1612d_rf2xh_59",
  "variant-normal": "awsui_variant-normal_1612d_rf2xh_67",
  "variant-disabled": "awsui_variant-disabled_1612d_rf2xh_70",
  "variant-inverted": "awsui_variant-inverted_1612d_rf2xh_73",
  "circle": "awsui_circle_1612d_rf2xh_77",
  "circle-left": "awsui_circle-left_1612d_rf2xh_101",
  "spinner-line-left": "awsui_spinner-line-left_1612d_rf2xh_1",
  "circle-right": "awsui_circle-right_1612d_rf2xh_106",
  "spinner-line-right": "awsui_spinner-line-right_1612d_rf2xh_1"
};
  